<template>
  <FormControl
    :label="i18n.app.components.contract.conked_out_license_plate"
    @disabled="onSetDisabled"
  >
    <input
      type="text"
      v-model="model[name]"
      @keyup="onKeyup($event.target.value)"
      @change="onChange($event.target.value)"
      class="form-control license"
      :class="getCountryCode()"
      placeholder
      :disabled="getIsDisabled()"
    />
  </FormControl>
</template>

<script>
import TextInput from "./TextInput";
import VehicleService from "@/services/VehicleService";
import FormControl from "./FormControl";
import formControlMixin from "./mixins/form-control.mixin.js";

const vehicleService = new VehicleService();

export default {
  name: "text-input-license-plate",
  props: ["label", "model", "name", "countryCode", "countries"],
  components: {
    TextInput,
    FormControl
  },
  mixins: [formControlMixin],
  methods: {
    getValue() {
      return this.model[this.name];
    },
    onKeyup(value) {
      this.model[this.name] = value.toUpperCase();
    },
    onChange(value) {
      const selectedCountry = this.countries.filter(country => country.iso_3166_2 === this.countryCode)[0]
      if (selectedCountry.is_supporting_address_search) {
        this.$emit("search");
        vehicleService
          .searchByLicensePlate(this.countryCode, value)
          .then(result => {
            this.$emit("searched", result);
          });
      }
    },
    getCountryCode() {
      return this.countryCode ? this.countryCode.toLowerCase() : null;
    }
  }
};
</script>

<style lang="scss" scoped>
input {
  padding-left: 2rem;
  text-align: center;
}
</style>
